import React, { useContext } from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Paper, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";

import { IAlimentoComposto } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";
import { StyledTableCell, StyledTableCellCabecalho, StyledTableHead } from "../../../Styles/tabelCellStyled/customTableCell";
import { func_print } from "../../../Func_genericas/func_print";
import { get } from "../../../Services/tokenConfig";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

interface IAlimentoCompostoProps {
    rows: IAlimentoComposto[];
    setRows: React.Dispatch<React.SetStateAction<IAlimentoComposto[]>>;
}

export const AlimentoComposto: React.FC<IAlimentoCompostoProps> = ({
    rows,
    setRows,
}) => {
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const auth = useContext(AuthContext);


    async function getTabela() {
        try {
            let res = await get(auth.token.cookie_token, `/get_alimento_composto_id_rosto/${location.state.id_identificacao}`);

            if (res.status === 200) {
                setRows(res.data.result.sort((a: any, b: any) => {
                    if (a.id_grupo > b.id_grupo) {
                        return 1;
                    }
                    if (a.id_grupo < b.id_grupo) {
                        return -1;
                    }
                    return 0;
                }));
            }
            setIsLoading(false);
        } catch (error) {
            func_print("getTabela", error, true);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        (async () => {
            await getTabela();
        })();
    }, []);


    return (
        <>
            {isLoading
                ? <LoadingVulpes /> :
                <TableContainer
                    component={Paper}
                    variant="outlined"
                    sx={{
                        height: "auto",
                        width: "auto",
                        margin: 2,
                        padding: 2,
                    }}
                >
                    <table style={{ width: "100%" }}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCellCabecalho
                                    colSpan={7}
                                    sx={{ fontWeight: 600, fontSize: 14 }}
                                >
                                    2.5. Alimento Composto
                                </StyledTableCellCabecalho>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead rowSpan={4}> Efetivo Pecuário </StyledTableHead>
                                <StyledTableHead colSpan={6} >Alimento composto</StyledTableHead>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead colSpan={6} >Aditivos</StyledTableHead>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead rowSpan={2} >Organoléticos</StyledTableHead>
                                <StyledTableHead rowSpan={2} >Nutritivos</StyledTableHead>
                                <StyledTableHead colSpan={4} >Zootécnicos</StyledTableHead>
                            </TableRow>
                            <TableRow>
                                <StyledTableHead>Ambientais</StyledTableHead>
                                <StyledTableHead>Melhoradores digestibilidade</StyledTableHead>
                                <StyledTableHead>Estabilizadores  flora gástrica</StyledTableHead>
                                <StyledTableHead>Outros zootécnicos</StyledTableHead>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows === undefined || rows.length === 0 ? <></> :
                                rows.map((row, index) => (
                                    <TableRow key={index}>
                                        <StyledTableCell > Grupo Homogéneo {index + 1}</StyledTableCell>
                                        <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.organoléticos === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.organoléticos)} </StyledTableCell>
                                        <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.nutritivos === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.nutritivos)} </StyledTableCell>
                                        <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.ambientais === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.ambientais)} </StyledTableCell>
                                        <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.melhoradores === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.melhoradores)} </StyledTableCell>
                                        <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.estabbilizadores === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.estabbilizadores)} </StyledTableCell>
                                        <StyledTableCell sx={{ backgroundColor: "lightgrey" }}>{row.outros === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(row.outros)} </StyledTableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </table>
                </TableContainer>
            }
        </>
    );
}